/**
 * INTERNAL CONFIGURATION & FLAGS
 *
 * These constants represent internal-usage config flags.
 * They are candidates to be promoted as env vars whenever is needed.
 */

import { createConfigFromLocalStorage } from './config.utils';

export const config = {
  // FORMATTING CONSTANTS
  FORMAT_NULLABLE_CHARACTER: '-',
  FORMAT_SEPARATOR_CHARACTER: '‧',
  FORMAT_MAX_INPUT_LENGTH: 250,
  FORMAT_MAX_TEXTAREA_LENGTH_SHORTEST: 250,
  FORMAT_MAX_TEXTAREA_LENGTH_SHORT: 500,
  FORMAT_MAX_TEXTAREA_LENGTH_MEDIUM: 1000,
  FORMAT_MAX_TEXTAREA_LENGTH_LONG: 2000,
  FORMAT_NUMBER_SIMPLE_FRACTION_DIGITS: 1,
  FORMAT_NUMBER_REGULAR_FRACTION_DIGITS: 2,
  FORMAT_NUMBER_PRECISION_FRACTION_DIGITS: 3,
  FORMAT_NUMBER_USE_GROUPING: false,

  // TIMING CONSTANTS
  TIMING_THROTTLE_WAIT_60FPS_MS: 16.6,
  TIMING_THROTTLE_WAIT_SHORT_MS: 50,
  TIMING_THROTTLE_WAIT_STANDARD_MS: 125,
  TIMING_THROTTLE_WAIT_LONG_MS: 250,
  TIMING_DEBOUNCE_WAIT_MS: 125,
  REDIRECT_COUNTDOWN_MS: 8000,

  // APP CONSTANTS
  SEARCH_DEFAULT_MIN_CHARACTERS: 1,
  SEARCH_DEFAULT_DEBOUNCE_MILLIS: 500,
};

export type Config = typeof config;

/**
 * LOCAL STORAGE CONFIGURATION & FLAGS
 *
 * These constants represent internal-usage config flags which values are stored
 * and exposed vida local storage.
 * They are candidates to be promoted as env vars whenever is needed.
 */
const configLocalDefaultValues = {
  DEBUG_I18N_KEYS: false,
};

export const configLocal = createConfigFromLocalStorage(configLocalDefaultValues);

export type ConfigLocal = typeof configLocal;
